import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import { Filter, Settings } from 'lucide-react';

const DecisionNode = ({ data, selected }) => {
  const [showConfig, setShowConfig] = useState(false);
  
  return (
    <>
      <div className={`px-4 py-2 shadow-md rounded-lg bg-yellow-500 text-white border-2 ${
        selected ? 'border-yellow-300' : 'border-yellow-600'
      }`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Filter className="h-4 w-4" />
            <div className="text-sm font-medium">{data.label}</div>
          </div>
          <button
            onClick={() => setShowConfig(true)}
            className="p-1 hover:bg-yellow-600 rounded"
          >
            <Settings className="h-3 w-3" />
          </button>
        </div>
        
        {data.config?.condition && (
          <div className="text-xs mt-1 opacity-90">
            If: {data.config.condition}
          </div>
        )}
        
        <Handle
          type="target"
          position={Position.Top}
          style={{
            background: '#eab308',
            border: '2px solid #ca8a04',
          }}
        />
        
        {/* YES output */}
        <Handle
          type="source"
          position={Position.Right}
          id="yes"
          style={{
            background: '#22c55e',
            border: '2px solid #16a34a',
            top: '60%'
          }}
        />
        
        {/* NO output */}
        <Handle
          type="source"
          position={Position.Left}
          id="no"
          style={{
            background: '#ef4444',
            border: '2px solid #dc2626',
            top: '60%'
          }}
        />
      </div>

      {showConfig && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-lg font-semibold mb-4">Configure Decision Node</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Condition Type</label>
                <select className="mt-1 w-full border rounded-lg px-3 py-2">
                  <option>Value Comparison</option>
                  <option>Field Exists</option>
                  <option>Custom Expression</option>
                  <option>AI Evaluation</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Condition</label>
                <input 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="e.g., score > 0.8"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">True Path Label</label>
                  <input 
                    className="mt-1 w-full border rounded-lg px-3 py-2"
                    placeholder="Yes"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">False Path Label</label>
                  <input 
                    className="mt-1 w-full border rounded-lg px-3 py-2"
                    placeholder="No"
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-2 mt-6">
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 border rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DecisionNode;